
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";
import BaseAutocomplete from "@/components/base/design/BaseAutocomplete.vue";
import TagSelect from "@/components/base/TagSelect.vue";
import SvgRangeCalendar from "@/assets/icons/range-calendar.svg";
import { getFormatDate } from "@/utils/formatDates";
import { AFFILIATE_FIELD, CreateAffiliate, IAffiliateField } from "@/services/affiliates/CreateAffiliate";
import { createAffiliateTag, getAffiliateTags } from "@/api/user";
import MessengerSelect from "@/components/base/form/MessengerSelect.vue";
import PhoneNumberInput from "@/components/base/PhoneNumberInput.vue";
import BaseDateTimePicker from "@/components-UI/BaseDateTimePicker.vue";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";

@Component({
    components: {
        BaseTooltip,
        BaseDateTimePicker,
        PhoneNumberInput,
        MessengerSelect,
        SvgRangeCalendar,
        TagSelect,
        BaseAutocomplete,
    },
})

export default class createAffiliateFields extends Vue {
    @Prop({ required: true }) options!: IAffiliateField[];
    @PropSync('affiliate', { required: true }) affiliateSync!: CreateAffiliate;

    AFFILIATE_FIELD = AFFILIATE_FIELD;
    getAffiliateTags = getAffiliateTags;
    createAffiliateTag = createAffiliateTag;

    isShowPassword: boolean = false;

    /** Менеджер выбран мастер-аккаунтом: поле показываем текстом, без возможности править */
    isManagerFromMaster(item: IAffiliateField): boolean {
        return item.property === 'account_manager_id' && this.affiliateSync.isManagerFromMaster;
    }

    changeValue(property: string, value: any): void {
        this.affiliateSync[property] = value;
        if (property === 'master_id') this.affiliateSync.setManagerFromMaster(value);
    }

    setDate(property: string, value: string): void {
        if (value === '') delete this.affiliateSync[property];
        this.affiliateSync[property] = getFormatDate(value, 'yyyy-MM-dd');
    }
}

